import { SignupStepProps, hasServerErrorOn } from "../signupForm";
import {
  accountInfoErrors,
  prefilledSections,
} from "../account_info/accountInfo";

import { AccountInfoForm } from "../account_info/AccountInfoForm";
import { SignupStepFrame } from "../SignupStepFrame";

/** Step 1: the clinician's details and their facility, filled in from the NPI
 * lookup where it found them. */
export const AccountInfoStep = ({
  form,
  updateForm,
  npiLookup,
  serverErrors,
  onBack,
  onNext,
}: SignupStepProps) => {
  const prefilled = prefilledSections(npiLookup);
  return (
    <SignupStepFrame
      step="account_info"
      title={
        prefilled.personal || prefilled.facility
          ? "We found your information from the NPI:"
          : "Please enter your information"
      }
      // From the form, so the greeting follows an edited name.
      eyebrow={
        prefilled.personal && form.firstName.trim()
          ? `Hello ${form.firstName.trim()}!`
          : undefined
      }
      eyebrowStyle="greeting"
      onBack={onBack}
      onNext={onNext}
      nextDisabled={
        Object.keys(accountInfoErrors(form)).length > 0 ||
        hasServerErrorOn("account_info", serverErrors)
      }
    >
      <AccountInfoForm
        form={form}
        updateForm={updateForm}
        serverErrors={serverErrors}
        prefilled={prefilled}
        practiceLocations={npiLookup?.practice_locations ?? []}
      />
    </SignupStepFrame>
  );
};
